import { styled } from '@mui/material';

import { useNavigate, useParams } from 'react-router';

import { OpenIcon, PrototypesIcon } from '@app-velocity/icons';
import {
  Box,
  ButtonsContainer,
  InfoBox,
  RoundIcon,
  Button,
} from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';

import { useAppContext } from '@app-velocity/config';

import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { MessageBus } from '@app-velocity/message-bus';

import { ScenarioRoutePaths } from '../../../../routes/ScenariosRoutePaths';

const StyledBox = styled(Box)({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'pre-wrap',
  flex: 1,
});

const teamsMessageBus = new MessageBus('teams');

export const NoScenarios = () => {
  const { t } = useI18n();

  const { workspaceId, teamId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();
  const navigate = useNavigate();
  const currentTeam = useCurrentTeamPermissions();

  const { scenarioExample, scenarioDemo } = useAppContext();

  const openExample = (e: React.MouseEvent) => {
    e.stopPropagation();

    window.open(scenarioExample);
  };

  const openDemo = (e: React.MouseEvent) => {
    e.stopPropagation();

    window.open(scenarioDemo);
  };

  const goToNewScenario = () => {
    if (!currentTeam) return;

    const higherTieredTeam = currentTeam.getHigherTieredTeam();

    if (higherTieredTeam) {
      teamsMessageBus.publish('modal:paid-team-available:open', {
        team: higherTieredTeam,
        redirectToSelectFlow: true,
        onModalCloseCallback: () => {
          navigate(ScenarioRoutePaths.challengeAFlow(teamId!, workspaceId!));
        },
      });

      return;
    }

    if (!currentTeam.canRunSimulations(1)) {
      return;
    }

    navigate(ScenarioRoutePaths.challengeAFlow(teamId!, workspaceId!));
  };

  return (
    <StyledBox>
      <RoundIcon icon={<PrototypesIcon />} />
      <InfoBox
        title="prototypes:no_challenges"
        description="prototypes:no_challenges_description"
        content={
          <Button
            variant="contained"
            color="primary"
            onClick={goToNewScenario}
            data-ph-capture-attribute-id="challenge_flow_button"
          >
            {t('prototypes:challenge_a_flow')}
            <PrototypesIcon />
          </Button>
        }
      />
      <ButtonsContainer>
        <Button size="small" onClick={openExample} color="secondary">
          {t('shared:where_to_start.example')}
          <OpenIcon />
        </Button>
        <Button size="small" onClick={openDemo} color="secondary">
          {t('shared:where_to_start.watch_demo')}
          <OpenIcon />
        </Button>
      </ButtonsContainer>
    </StyledBox>
  );
};
